import apiClient, { apiRequest } from "./apiClient";

/**
 * Create a new organization-provider integration
 * Calls: POST /api/v1/organization-provider-integrations
 * @param {Object} integrationData - Integration configuration data
 * @returns {Promise<{success: boolean, data?: Object, message?: string}>}
 */
export const createIntegration = async (integrationData) => {
  return apiRequest(
    () =>
      apiClient.post(
        `/api/v1/organization-provider-integrations`,
        integrationData
      ),
    "Failed to create integration"
  );
};

/**
 * Get integrations for an organization
 * Calls: GET /api/v1/organization-provider-integrations
 * @param {Object} params - Query parameters
 *   - provider_id: string (UUID)
 *   - provider_api_id: string (UUID)
 *   - is_enabled: boolean
 *   - limit: number
 *   - offset: number
 * @returns {Promise<{success: boolean, data?: Array, message?: string}>}
 */
export const getIntegrations = async (params = {}) => {
  const queryParams = new URLSearchParams();

  if (params.provider_id) queryParams.append("provider_id", params.provider_id);
  if (params.provider_api_id)
    queryParams.append("provider_api_id", params.provider_api_id);
  if (params.is_enabled !== undefined)
    queryParams.append("is_enabled", params.is_enabled);
  if (params.limit) queryParams.append("limit", params.limit);
  if (params.offset !== undefined) queryParams.append("offset", params.offset);

  const queryString = queryParams.toString();
  const url = queryString
    ? `/api/v1/organization-provider-integrations?${queryString}`
    : `/api/v1/organization-provider-integrations`;

  return apiRequest(() => apiClient.get(url), "Failed to fetch integrations");
};

/**
 * Update an existing integration
 * Calls: PATCH /api/v1/organization-provider-integrations/{id}
 * @param {string} integrationId - Integration ID
 * @param {Object} integrationData - Updated integration data
 * @returns {Promise<{success: boolean, data?: Object, message?: string}>}
 */
export const updateIntegration = async (integrationId, integrationData) => {
  return apiRequest(
    () =>
      apiClient.patch(
        `/api/v1/organization-provider-integrations/${integrationId}`,
        integrationData
      ),
    "Failed to update integration"
  );
};
